import { render, staticRenderFns } from "./TabsOriginal.vue?vue&type=template&id=9da9dd20&scoped=true&"
import script from "./TabsOriginal.vue?vue&type=script&lang=js&"
export * from "./TabsOriginal.vue?vue&type=script&lang=js&"
import style0 from "./TabsOriginal.vue?vue&type=style&index=0&id=9da9dd20&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da9dd20",
  null
  
)

export default component.exports